import controller from './layout.controller';

const template = require('./layout.html');

export default {
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/common/layout/layout.component.js